import { GeneralSettingsType } from '@type/general-settings.type';

/** The key the settings blob occupies inside `/me/options`. */
export const GENERAL_SETTINGS_OPTION_KEY = 'general_settings';

/**
 * Defaults chosen so an account that has never opened the screen behaves
 * exactly as the app did before it existed: Melbourne time, the `dd MMM yyyy`
 * format already used in templates, a 12-hour clock, no idle logout, and the
 * 10 MB ceiling the document uploaders hardcoded.
 */
export const GENERAL_SETTINGS_DEFAULTS: GeneralSettingsType = {
  timezone: 'Australia/Melbourne',
  date_format: 'dd MMM yyyy',
  time_format: '12h',
  session_timeout_minutes: 0,
  max_upload_mb: 10,
};

/** Zones offered in the Date & Time card — every Australian sales market. */
export const TIMEZONE_OPTIONS: { id: string; label: string }[] = [
  { id: 'Australia/Melbourne', label: '(UTC+10:00) Melbourne' },
  { id: 'Australia/Sydney', label: '(UTC+10:00) Sydney' },
  { id: 'Australia/Brisbane', label: '(UTC+10:00) Brisbane' },
  { id: 'Australia/Adelaide', label: '(UTC+09:30) Adelaide' },
  { id: 'Australia/Darwin', label: '(UTC+09:30) Darwin' },
  { id: 'Australia/Perth', label: '(UTC+08:00) Perth' },
  { id: 'Australia/Hobart', label: '(UTC+10:00) Hobart' },
  { id: 'Asia/Hong_Kong', label: '(UTC+08:00) Hong Kong' },
  { id: 'Asia/Singapore', label: '(UTC+08:00) Singapore' },
];

/** Labels carry a worked example so the difference is obvious at a glance. */
export const DATE_FORMAT_OPTIONS: { id: string; label: string }[] = [
  { id: 'dd MMM yyyy', label: '28 Jul 2026' },
  { id: 'dd/MM/yyyy', label: '28/07/2026' },
  { id: 'MM/dd/yyyy', label: '07/28/2026' },
  { id: 'yyyy-MM-dd', label: '2026-07-28' },
];

export const TIME_FORMAT_OPTIONS: { id: string; label: string }[] = [
  { id: '12h', label: '12 Hour (02:30 PM)' },
  { id: '24h', label: '24 Hour (14:30)' },
];

/** `0` is "never" — the timer is opt-in. */
export const SESSION_TIMEOUT_OPTIONS: { id: number; label: string }[] = [
  { id: 0, label: 'Never' },
  { id: 15, label: '15 minutes' },
  { id: 30, label: '30 minutes' },
  { id: 60, label: '1 hour' },
  { id: 120, label: '2 hours' },
];

export const MAX_UPLOAD_OPTIONS: { id: number; label: string }[] = [
  { id: 2, label: '2 MB' },
  { id: 5, label: '5 MB' },
  { id: 10, label: '10 MB' },
  { id: 25, label: '25 MB' },
  { id: 50, label: '50 MB' },
];
